// removed by extract-text-webpack-plugin
module.exports = {"container":"_3y1p05hqX45wJldOtFkYGO","controls":"_1XmGWTPvJRDG3dUMQLjmS9","cancelBtn":"_2YpTfNCWqeqJhjiUX2y44v","successBtn":"_1spTZMtRmm0b9jb20zr7k8","label":"_3gzf2RFMkxEoXrMnoCW7fP","settingList":"_3CBfONMCj05Y3H9hi6uTXc","settingContainer":"_282SwxQQBz3C0UU6kuG9Rt","setting":"_1cj3xgXWrZBwsvHAVyko5w","description":"_1TyUX-YbEI5OJdY0aY6_04"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Notifications/NotificationSettings/NotificationSettings.pcss
// module id = 496
// module chunks = 0